import { InjectionToken } from "@angular/core";

/**
 * interfaces
*/
import {
    IAuthJwtService,
    IAuthAccessTokenService,
    IAuthLoggedInService,
    IAuthControlsService,
    IAuthSessionManagementService,
    IAuthLoginService,
    IAuthLogoutService,
} from "../interfaces";

/**
 * Injection token for JWT authentication service
 * @constant {InjectionToken<IAuthJwtService>} AUTH_JWT
 * @description Token used to inject JWT-specific authentication services
 */
export const AUTH_JWT = new InjectionToken<IAuthJwtService>('AUTH_JWT');

/**
 * Injection token for access token service
 * @constant {InjectionToken<IAuthAccessTokenService>} AUTH_ACCESS_TOKEN
 * @description Token used to inject access token services
 */
export const AUTH_ACCESS_TOKEN = new InjectionToken<IAuthAccessTokenService>('AUTH_ACCESS_TOKEN');

/**
 * Injection token for login state authentication service
 * @constant {InjectionToken<IAuthLoggedInService>} AUTH_IS_LOGGED_IN
 * @description Token used to inject login state authentication services
 */
export const AUTH_IS_LOGGED_IN = new InjectionToken<IAuthLoggedInService>('AUTH_IS_LOGGED_IN');

/**
 * Injection token for authentication control service
 * @constant {InjectionToken<IAuthControlsService>} AUTH_CONTROLS
 * @description Token used to inject authentication control and management services
 */
export const AUTH_CONTROLS = new InjectionToken<IAuthControlsService>('AUTH_CONTROLS');

/**
 * Injection token for authentication login service
 * @constant {InjectionToken<IAuthLoginService>} AUTH_LOGIN
 * @description Token used to inject authentication login services
 */
export const AUTH_LOGIN = new InjectionToken<IAuthLoginService>('AUTH_LOGIN');

/**
 * Injection token for authentication logout service
 * @constant {InjectionToken<IAuthLogoutService>} AUTH_LOGOUT
 * @description Token used to inject authentication logout services
 */
export const AUTH_LOGOUT = new InjectionToken<IAuthLogoutService>('AUTH_LOGOUT');

/**
 * Injection token for session management service
 * @constant {InjectionToken<IAuthSessionManagementService>} AUTH_SESSION_MANAGEMENT
 * @description Token used to inject session management services
 */
export const AUTH_SESSION_MANAGEMENT = new InjectionToken<IAuthSessionManagementService>('AUTH_SESSION_MANAGEMENT');
